import React, { useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import Lelo from "./logo-lelotrip.png";
import "./Navbars.css";
import {
  FaCrown,
  FaEnvelope,
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaRegUser,
  FaUserAlt,
  FaUserCircle,
} from "react-icons/fa";
import { IoMdGlobe, IoMdNotificationsOutline } from "react-icons/io";
import {
  MdChatBubbleOutline,
  MdEmail,
  MdLogout,
  MdWhatsapp,
} from "react-icons/md";
import { GrAnnounce } from "react-icons/gr";
import { Link, useNavigate } from "react-router-dom";
import SignUp from "./SignUp";
import { HiOutlineMenuAlt2 } from "react-icons/hi";

import ProtectedLink from "../ProtectedLink";
import { useAuth } from "../../context/AuthContext";
import { CountriesArray } from "./Countries";
import { FaPhoneVolume, FaRegCircleUser, FaXTwitter } from "react-icons/fa6";
import { IoPersonCircleOutline, IoTicketOutline } from "react-icons/io5";
import { AiOutlineUser } from "react-icons/ai";
import { RiWallet3Line } from "react-icons/ri";
import { BsBoxArrowInRight } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { loggedOut } from "../../redux/slices/login";
// import { useAuth } from "../../context/AuthContext";

const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
};
const Navbars = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState(false);
  const [show, setShow] = useState(false);
  const isAuth = useSelector((state) => state.authenticate.isAuth);
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [names, setNames] = useState("");
  useEffect(() => {
    const emaill = localStorage.getItem("email");
    setEmail(emaill);
    const names = localStorage.getItem("names");
    setNames(names);
  }, [isAuth, loggedOut]);
  const handleAuthClick = () => {
    if (isAuth) {
      dispatch(loggedOut());
    } else {
      handleShow();
      setExpanded(false);
      setShowSideNav(false);
    }
  };

  const [otpSent, setOtpSent] = useState(false);
  const handleClose = () => {
    setShow(false);
    // setOtpSent(false)
  };
  const handleShow = () => setShow(true);

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    setExpanded(false);
  };
  const [expanded, setExpanded] = useState(false);
  const [showSideNav, setShowSideNav] = useState(false);
  const [isOpen, setIsOpen] = useState(false); // For dropdown
  const [selectedCountry, setSelectedCountry] = useState({
    code: "in",
    name: "India",
  });

  const width = useWindowWidth();

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsOpen(false);
  };

  const toggleDropdown = () => setIsOpen(!isOpen);

  const [isSidebarCountryOpen, setIsSidebarCountryOpen] = useState(false);
  const toggleSidebarCountryDropdown = () => {
    setIsSidebarCountryOpen(!isSidebarCountryOpen);
  };
  const handleSidebarCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsSidebarCountryOpen(false);
  };

  const handleToggle = () => {
    const isPhone = width <= 998;
    if (isPhone) {
      setShowSideNav(true); // Show custom side nav
      setExpanded(false); // Make sure collapse nav stays closed
    } else {
      setExpanded(expanded ? false : "expanded"); // Toggle Bootstrap collapse on desktop
      setShowSideNav(false); // Just in case it's open, hide it
    }
  };

  const [showHelpDropdown, setShowHelpDropdown] = useState(false);

  const toggleHelpDropdown = () => {
    setShowHelpDropdown((prev) => !prev);
  };
  const [showMore, setShowMore] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);

  const handleMouseEnter = () => setShowDropdown(true);
  const handleMouseLeave = () => setShowDropdown(false);

  const [showSupport, setShowSupport] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const handleMyAccount = (tabIndex = 1) => {
    navigate("/bookings/flight", { state: { activeTab: tabIndex } });
    setShowSideNav(false);
    setShowProfileDropdown(false);
    setExpanded(false);
  };
  const handleSupport =()=>{
    navigate("/contact");
    setShowSideNav(false); 
  }
  const handleLoginClick = () => {
    handleShow();
    setExpanded(false);
    setShowSideNav(false);
  };
  const handleLoginFunc = () => {
    setShowSideNav(false);
    setShow(true);
  };

  return (
    <div className="main-nav">
      <div
        id="opct3"
        className="_opcMenu"
        style={{ display: showSideNav ? "block" : "none" }}
      ></div>
      <Navbar
        bg="white"
        expand="lg"
        className="p-0"
        collapseOnSelect
        expanded={expanded}
        style={{ border: "none" }}
      >
        <Container>
          <Navbar.Toggle onClick={handleToggle}>
            <HiOutlineMenuAlt2 size={24} />
          </Navbar.Toggle>
          <div
            id="mySidenav_v3"
            className="_sidenav"
            style={{ width: "75%", display: showSideNav ? "block" : "none" }}
          >
            <div className="">
              <a
                className="closemenu_v3"
                onClick={(e) => {
                  e.preventDefault();
                  setShowSideNav(false);
                }}
              >
                ×
              </a>

              <div
                id="divSignInPnl"
                className="divSignInPnl"
                onClick={() => {
                  if (isAuth) {
                    navigate("/bookings/flight");
                    setShowSideNav(false);
                  } else {
                    handleAuthClick();
                  }
                }}
              >
                <div
                  className="_menuProf menu_top_Tg menu_trip_go_card"
                  style={{ gap: "15px", alignItems: "center", border: "none" }}
                >
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "50px",
                      padding: "5px",
                    }}
                  >
                    <AiOutlineUser size={35} color="#1d489f" />
                  </div>
                  {isAuth ? (
                    <div className="_logRt">
                      <div className="_logSinup"> Hi {names}</div>
                      <div className="_logDt"> {email}</div>
                    </div>
                  ) : (
                    <div className="_logRt">
                      <div className="_logSinup">Login or Signup</div>
                      <div className="_logDt"> and Grab Exclusive deals</div>
                    </div>
                  )}
                </div>
              </div>

              <div
                style={{
                  width: "90%",
                  margin: "auto",
                }}
              >
                <div
                  className="_menuProf"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="inner_account_nav" onClick={() => handleMyAccount(1)}>
                    <div className="inner_acc">
                      <FaRegUser color="#fff" size={20} />
                    </div>
                    <p>My Account</p>
                  </div>

                  <div className="inner_account_nav">
                    <div className="inner_acc">
                      <MdChatBubbleOutline color="#fff" size={20} />
                    </div>
                    <p className="">Notifications</p>
                  </div>
                  <div className="inner_account_nav" onClick={handleSupport}>
                    <div className="inner_acc">
                      <IoMdNotificationsOutline color="#fff" size={20} />
                    </div>
                    <p>Support</p>
                  </div>
                </div>
              </div>
              <div className="_sidMenu">
                <div className="_sidMenu_tggg" onClick={() => handleMyAccount(2)}>
                  <a>
                    <div className="_bxIcn">
                      <div className="_menuIcn">
                        <IoTicketOutline color="#1d489f" size={25} />
                      </div>
                      <div className="_logRgt">
                        <div className="_hTxt"> My Booking</div>
                        <p className="_mTxt">
                          {" "}
                          View and manage your <br />
                          bookings
                        </p>
                      </div>
                    </div>
                    <i
                      className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                    />
                  </a>
                </div>

                <div className="_sidMenu_tggg" onClick={() => handleMyAccount(1)}>
                  <a>
                    <div className="_bxIcn">
                      <div className="_menuIcn">
                        <RiWallet3Line color="#1d489f" size={25} />
                      </div>
                      <div className="_logRgt">
                        <div className="_hTxt">Innovate Blues Wallet</div>
                        <p className="_mTxt">
                          {" "}
                          Use your wallet for hassle- <br />
                          free booking
                        </p>
                      </div>
                    </div>
                    <i
                      className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                    />
                  </a>
                </div>

                <div className="_sidMenu_tggg">
                  <a>
                    <div className="_bxIcn">
                      <div className="_menuIcn">
                        <GrAnnounce color="#1d489f" size={25} />
                      </div>
                      <div className="_logRgt">
                        <div className="_hTxt">Earn & Refer</div>
                        <p className="_mTxt">
                          {" "}
                          Refer a friend and invite them  <br />
                          to Sign Up
                        </p>
                      </div>
                    </div>
                    <i
                      className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                    />
                  </a>
                </div>

              </div>

              <div className="_sidMenu" style={{ marginTop: "10px" }}>
                <div className="_sidMenu_tggg">
                  <Link
                    to="https://instagram.com/tripgo_online?igshid=YmMyMTA2M2Y="
                    target="_blank"
                  >
                    <div className="_bxIcn">
                      <div className="_menuIcn">
                        {/* Instagram Gradient or closest solid color */}
                        <FaInstagram color="#E4405F" size={25} />
                      </div>
                      <div className="_logRgt">
                        <div className="_hTxt">Instagram</div>
                      </div>
                    </div>
                    <i
                      className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                    />
                  </Link>
                </div>

                <div className="_sidMenu_tggg">
                  <Link
                    to="https://www.facebook.com/TravelTGO/"
                    target="_blank"
                  >
                    <div className="_bxIcn">
                      <div className="_menuIcn">
                        {/* Facebook Blue */}
                        <FaFacebookSquare color="#1877F2" size={25} />
                      </div>
                      <div className="_logRgt">
                        <div className="_hTxt">Facebook</div>
                      </div>
                    </div>
                    <i
                      className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                    />
                  </Link>
                </div>

                <div className="_sidMenu_tggg ">
                  <Link to="https://twitter.com/Innovate Blues" target="_blank">
                    <div className="_bxIcn">
                      <div className="_menuIcn">
                        {/* X (Twitter) Black */}
                        <FaXTwitter color="#000000" size={25} />
                      </div>
                      <div className="_logRgt">
                        <div className="_hTxt">Twitter</div>
                      </div>
                    </div>
                    <i
                      className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                    />
                  </Link>
                </div>
              </div>


              <div className="_sidMenu">
                 <a onClick={toggleSidebarCountryDropdown} style={{ cursor: "pointer" }}>
                  <div className="_bxIcn" onClick={toggleHelpDropdown}>
                    <div className="_menuIcn" style={{ marginTop: "7px" }}>
                      <i
                        className="_yourBoking"
                        style={{
                           backgroundImage: `url(https://flagcdn.com/w20/${selectedCountry.code}.png)`,

                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                        }}
                      />
                    </div>
                    <div className="_logRgt">
                      <p className="_mTxt">Country / Region</p>
                      <div className="_hTxt">{selectedCountry.name} </div>
                    </div>
                  </div>
                  <i
                    className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                  />
                </a>
                {/* <div onClick={toggleSidebarCountryDropdown} style={{ cursor: "pointer" }}>
                  <div className="_bxIcn">
                    <div className="_menuIcn" style={{ marginTop: "7px" }}>
                       <img
                          src={`https://flagcdn.com/w20/${selectedCountry.code}.png`}
                          alt=""
                          style={{ width: "25px", borderRadius: "2px" }} 
                        />
                    </div>
                    <div className="_logRgt">
                      <p className="_mTxt">Country / Region</p>
                      <div className="_hTxt" style={{display:'flex', alignItems:'center', gap:'5px'}}>
                        {selectedCountry.name} 
                        <i className={`_arrwdnlang ${isSidebarCountryOpen ? "open" : ""}`} style={{ marginTop: "0" }}></i>
                      </div>
                    </div>
                  </div>
                </div> */}
                {isSidebarCountryOpen && (
                   <div className="dropdown-options" style={{
                      position: "relative",
                      width: "100%",
                      top: "0",
                      boxShadow: "none",
                      border: "1px solid #eee",
                      borderRadius: "8px",
                      marginTop: "5px",
                      maxHeight: "200px",
                      overflowY: "auto"
                   }}>
                    {CountriesArray.map((country, index) => (
                      <div
                        key={index}
                        className="option"
                        onClick={() => handleSidebarCountrySelect(country)}
                        style={{ padding: "8px 15px" }}
                      >
                        <img
                          src={`https://flagcdn.com/w20/${country.code}.png`}
                          alt=""
                          style={{ marginRight: "10px" }}
                        />
                        <span>{country.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="_sidMenu">
                <a onClick={handleAuthClick}>
                  <div className="_bxIcn" onClick={toggleHelpDropdown}>
                    <div className="_menuIcn" style={{ marginTop: "7px" }}>
                      <BsBoxArrowInRight size={25} color="#aa0000" />
                    </div>
                    <div className="_logRgt">
                      <div className="_hTxt" style={{ color: "#aa0000" }}>
                        {isAuth ? "Sign Out" : "Login"}
                      </div>
                    </div>
                  </div>
                  <i
                    className={`_arwwLft ${showHelpDropdown ? "rotate" : ""}`}
                  />
                </a>
              </div>

              <div className="_sidMenu tLogout" style={{ display: "none" }}>
                <a>
                  <div className="_bxIcn">
                    <div className="_menuIcn">
                      <i className="_logOut" />
                    </div>
                    <div className="_logRgt">
                      <div className="_hTxt">
                        {" "}
                        {isAuth ? "Sign Out" : "Login"}
                      </div>
                    </div>
                  </div>
                  <i className="_arwwLft" />
                </a>
              </div>
            </div>

            <link id="linkb2bMenu" href="" rel="stylesheet" />

            <div className="bg_ovrly" style={{ display: "none" }} />
          </div>

          <Navbar.Collapse
            id="navbarCollapse"
            style={{
              order: expanded && "4",
              paddingBottom: expanded && "10px",
            }}
          >
            <Nav className="me-auto py-4 py-lg-0">
              <Nav.Link
                as={Link}
                to="/"
                className="d-flex align-items-center hvr-underline-reveal"
              >
                <img
                  src="/Images/Icons/flightss.png"
                  width={40}
                  alt="Flights Icon"
                  className="navbar_icons_Image"
                />
                Flights
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/hotel"
                className="d-flex align-items-center hvr-underline-reveal"
                onClick={() => setExpanded(false)}
              >
                <img
                  src="/Images/Icons/hotelss.png"
                  width={40}
                  alt="Hotel Icon"
                  className="navbar_icons_Image"
                />
                Hotels
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/tour"
                onClick={() => setExpanded(false)}
                className="d-flex align-items-center hvr-underline-reveal"
              >
                <img
                  src="/Images/Icons/holidayss.png"
                  width={40}
                  alt="Holidays Icon"
                  className="navbar_icons_Image"
                />
                Holidays
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/buses"
                onClick={() => setExpanded(false)}
                className="d-flex align-items-center hvr-underline-reveal"
              >
                <img
                  src="/Images/Icons/busess.png"
                  width={40}
                  alt="Bus Icon"
                  className="navbar_icons_Image"
                />
                Buses
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/cabs"
                onClick={() => setExpanded(false)}
                className="d-flex align-items-center hvr-underline-reveal"
              >
                <img
                  src="/Images/Icons/cabss.png"
                  width={40}
                  alt="Cabs Icon"
                  className="navbar_icons_Image"
                />
                Cabs
              </Nav.Link>

                {!isAuth && (
                  <Nav.Link
                    as={Link}
                    to="/bookings/flight"
                    onClick={() => setExpanded(false)}
                    className="d-flex align-items-center hvr-underline-reveal"
                  >
                    <img
                      src="/Images/Icons/mybookingss.png"
                      alt="My Bookings"
                      style={{ height: "28px", width: "28px", marginRight: "8px" }}
                    />
                    My Bookings
                  </Nav.Link>
                )}

              <Nav
                className="ml-auto support_link"
                onMouseLeave={handleMouseLeave}
              >
                <NavDropdown
                  title={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src="/Images/Icons/supportss.png"
                        alt="Support"
                        style={{
                          height: "28px",
                          width: "28px",
                          marginRight: "8px",
                        }}
                      />
                      Support
                    </span>
                  }
                  id="navbarDropdown"
                  className="no-border support_link"
                  style={{ padding: "0px" }}
                  show={showDropdown}
                  onMouseEnter={handleMouseEnter}
                >
                  <NavDropdown.Item>
                    <div className="cus_icon">
                      <FaUserCircle className="icon" />
                    </div>
                    <div className="cus_txt">
                      <span className="title">Account Manager</span>
                      <span className="sub_txt">
                        +91 9718278968 <br /> support@innovateblues.com
                      </span>
                    </div>
                  </NavDropdown.Item>
                  <NavDropdown.Item>
                    <div className="cus_icon">
                      <IoMdGlobe className="icon" />
                    </div>
                    <div className="cus_txt">
                      <span className="title">Customer Support</span>
                      <span className="sub_txt">
                        support@innovateblues.com
                        <br /> +91 9718278968
                      </span>
                    </div>
                  </NavDropdown.Item>
                  <NavDropdown.Item  href="https://wa.me/919718278968"
  target="_blank">
                    <div className="cus_icon whatsapp_icon">
                      <MdWhatsapp className="icon" />
                    </div>
                    <div className="cus_txt">
                      <span className="title" style={{ marginTop: "6px" }}>
                        +91 9718278968
                      </span>
                    </div>
                  </NavDropdown.Item>
                  <a href="mailto:support@innovateblues.com" className="dropdown-item">
                    <div className="cus_icon">
                      <FaEnvelope className="icon" />
                    </div>
                    <div className="cus_txt">
                      <span className="title">For Booking</span>
                      <span className="sub_txt">support@innovateblues.com</span>
                    </div>
                  </a>

                  <a href="mailto:support@innovateblues.com" className="dropdown-item">
                    <div className="cus_icon">
                      <FaEnvelope className="icon" />
                    </div>
                    <div className="cus_txt">
                      <span className="title">For Refund</span>
                      <span className="sub_txt">support@innovateblues.com</span>
                    </div>
                  </a>

                </NavDropdown>
              </Nav>
              <Nav
                className="ml-auto support_link"
                onMouseLeave={() => {
                  setShowMore(false);
                  setShowSupport(false);
                }}
              >
                <NavDropdown
                  title={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src="/Images/Icons/more.png"
                        alt="More"
                        style={{
                          height: "30px",
                          width: "30px",
                          marginRight: "5px",
                        }}
                      />
                      More
                    </span>
                  }
                  id="moreDropdown"
                  className="no-border support_link"
                  show={showMore}
                  onMouseEnter={() => setShowMore(true)}
                  onMouseLeave={() => setShowMore(false)}
                >
                  {/* My Bookings */}
                  <NavDropdown.Item
                    className="support_link"
                    style={{ display: "flex", alignItems: "center" }}
                    as={Link}
                    to="/insurance"
                  >
                    <img
                      src="/Images/Icons/insurancess.png"
                      alt="My Bookings"
                      style={{
                        height: "28px",
                        width: "28px",
                        marginRight: "8px",
                      }}
                    />
                    Insurance
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="support_link"
                    style={{ display: "flex", alignItems: "center" }}
                    as={Link}
                    to="/visa"
                  >
                    <img
                      src="/Images/Icons/visass.png"
                      alt="My Bookings"
                      style={{
                        height: "28px",
                        width: "28px",
                        marginRight: "8px",
                      }}
                    />
                    Visa
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="support_link"
                    style={{ display: "flex", alignItems: "center" }}
                    as={Link}
                    to="/forex"
                  >
                    <img
                      src="/Images/Icons/forexss.png"
                      alt="My Bookings"
                      style={{
                        height: "28px",
                        width: "28px",
                        marginRight: "8px",
                      }}
                    />
                    Forex
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Nav>
            <div
              className="flex flex-middle px-1"
              style={{ marginLeft: "12px" }}
            >
<div className="d-flex c-pointer" style={{ position: "relative" }}>
                {isAuth ? (
                  <div
                    onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                    className="d-flex align-items-center profile-trigger"
                    style={{
                      display: expanded ? "none" : "flex", 
                      alignItems: "center",
                      background: showProfileDropdown ? '#1d489f' : 'linear-gradient(20deg, rgb(111 166 194) 20%, rgb(2 69 117) 100%)',
                      paddingRight: '15px'
                    }}
                  >
                    <IoPersonCircleOutline
                      size={24}
                      color="#fff"
                      style={{ marginRight: "5px" }}
                    />
                    <span style={{ fontWeight: "700", color: "#fff", fontSize: '14px' }}>
                      Hi,Traveller
                    </span>
                    <i className={`_arrwdnlang ${showProfileDropdown ? "open" : ""}`} style={{ marginLeft: '8px', marginBottom: '2px' }}></i>

                    {showProfileDropdown && (
                      <div className="profile-dropdown-menu" onClick={(e) => e.stopPropagation()}>
                        
                        <div className="menu-item-hover mb-2" onClick={() => handleMyAccount(1)}>
                          <div className="menu-item-icon-box">
                            <FaRegUser size={18} color="#1d489f" />
                          </div>
                          <div className="menu-item-text-box">
                            <h6>My Profile</h6>
                            <p>Manage your profile and more</p>
                          </div>
                        </div>

                        
                        <div className="menu-item-hover" onClick={() => handleMyAccount(2)}>
                          <div className="menu-item-icon-box">
                            <IoTicketOutline size={18} color="#1d489f" />
                          </div>
                          <div className="menu-item-text-box">
                            <h6>My Booking</h6>
                            <p>Manage your bookings here</p>
                          </div>
                        </div>

                        <div style={{ height: '1px', backgroundColor: '#eee', margin: '8px 0' }}></div>

                        <div className="menu-item-hover logout-item" onClick={() => { handleAuthClick(); setShowProfileDropdown(false); }}>
                          <div className="menu-item-icon-box" style={{backgroundColor: '#fff5f5'}}>
                             <MdLogout size={18} color="#d32f2f" />
                          </div>
                          <div className="menu-item-text-box">
                            <h6 style={{color: '#d32f2f'}}>Log Out</h6>
                          </div>
                        </div>

                      </div>
                    )}
                  </div>
                ) : (
                  <button
                    onClick={handleAuthClick}
                    style={{ width: "max-content", display: expanded && "none" }}
                    className="hero-navbar-btnn h-10 br-6 bg-secondary-500 hover:bg-secondary-600 text-white border-transparent cursor-pointer py-1 px-3 font-weight-bold text-  border-solid text-500 border-1 rounded-4 line-height-solid box-border"
                  >
                    <IoPersonCircleOutline
                      size={22}
                      color="#fff"
                      style={{ marginTop: "-2px", marginRight: "2px" }}
                    />{" "}
                    Log In / Sign Up
                  </button>
                )}
              </div>
            </div>
          </Navbar.Collapse>
          <Navbar.Brand as={Link} to="/">
            <img
              className="logo-main me-2"
              src="https://innovateblues.com/images/logo.png"
              alt="Logo"
            />
          </Navbar.Brand>

          <div
            className="flex flex-middle px-1 singupbtn"
            style={{ marginLeft: "12px" }}
          >
            <div
              className="sharenation"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "7px",
              }}
            >
              <div
                className="_langview b2cpanel dropdown-header"
                onClick={toggleDropdown}
              >
                <span id="spnFlgImgHead">
                  <img
                    src={`https://flagcdn.com/w20/${selectedCountry.code}.png`}
                    alt=""
                  />
                </span>
                <span id="spnCC">{selectedCountry.name}</span>
                <i className={`_arrwdnlang ${isOpen ? "open" : ""}`}></i>
                {isOpen && (
                  <div className="dropdown-options">
                    {CountriesArray.map((country, index) => (
                      <div
                        key={index}
                        className="option"
                        onClick={() => handleCountrySelect(country)}
                      >
                        <img
                          src={`https://flagcdn.com/w20/${country.code}.png`}
                          alt=""
                        />
                        <span>{country.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Container>
      </Navbar>

      <SignUp
        show={show}
        setShow={setShow}
        handleClose={handleClose}
        handleShow={handleShow}
        otpSent={otpSent}
        setOtpSent={setOtpSent}
      />
    </div>
  );
};

export default Navbars;
